interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '可游漫画网',
      url: 'https://www.keyoumanhua.com',
      description: '可游漫画网提供无删减韩国漫画下拉式阅读，韩漫在线免费阅读资源齐全且持续更新。',
      email: 'contact@keyoumanhua.com',
      telephone: '+86-400-123-4567',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'CN',
        addressLocality: '北京',
        addressRegion: '朝阳区',
        streetAddress: '望京SOHO T3',
      },
      sameAs: [
        'https://weibo.com/keyoumanhua',
        'https://space.bilibili.com/keyoumanhua',
      ],
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '可游漫画网',
      url: 'https://www.keyoumanhua.com',
      description: '可游漫画网提供无删减韩国漫画下拉式阅读，韩漫在线免费阅读资源齐全且持续更新。',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        'target': 'https://www.keyoumanhua.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      inLanguage: 'zh-CN',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = schemas[type];
  if (!schema) return null;

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}